/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface PatchedRevision
 */
export interface PatchedRevision {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  repository?: string;
  /**
   *
   */
  number?: number;
  /**
   * unique identifier for changeset
   */
  hash?: string | null;
  /**
   *
   */
  commitDate?: Date | null;
  /**
   * user that committed the changeset for this revision
   */
  user?: string | null;
  /**
   *
   */
  isPinned?: boolean | null;
}

/**
 * Check if a given object implements the PatchedRevision interface.
 */
export function instanceOfPatchedRevision(value: object): value is PatchedRevision {
  return true;
}

export function PatchedRevisionFromJSON(json: any): PatchedRevision {
  return PatchedRevisionFromJSONTyped(json, false);
}

export function PatchedRevisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedRevision {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    repository: json["repository"] == null ? undefined : json["repository"],
    number: json["number"] == null ? undefined : json["number"],
    hash: json["hash"] === undefined ? undefined : json["hash"] === null ? null : json["hash"],
    commitDate:
      json["commit_date"] === undefined
        ? undefined
        : json["commit_date"] === null
        ? null
        : parseDateTime(json["commit_date"]),
    user: json["user"] === undefined ? undefined : json["user"] === null ? null : json["user"],
    isPinned:
      json["is_pinned"] === undefined
        ? undefined
        : json["is_pinned"] === null
        ? null
        : json["is_pinned"],
  };
}

export function PatchedRevisionToJSON(json: any): PatchedRevision {
  return PatchedRevisionToJSONTyped(json, false);
}

export function PatchedRevisionToJSONTyped(
  value?: Omit<PatchedRevision, "url" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    repository: value["repository"],
    number: value["number"],
    hash: value["hash"],
    commit_date:
      value["commitDate"] == null ? value["commitDate"] : serializeDateTime(value["commitDate"]),
    user: value["user"],
    is_pinned: value["isPinned"],
  };
}
